module.exports = __webpack_public_path__ + "static/media/pdf.worker.js.05a83c34.map";


//////////////////
// WEBPACK FOOTER
// ./~/pdfjs-dist/build/pdf.worker.js.map
// module id = 2875
// module chunks = 0